/**
 * Badge — pill compacta de status.
 *
 * Tokens vindos do protótipo (painel-screens.jsx:128-134):
 * - padding 2px 8px, radius 9999, fontSize 11, weight 500
 * - 4 variantes (success/warn/destructive/muted) com bg em rgba 14% e
 *   foreground na cor opaca correspondente.
 *
 * Usado em colunas de status do <DataTable> (TH-54207) e em listagens
 * com filtro por enum (TH-54208 / S2.5).
 */

import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export type BadgeVariant = "success" | "warn" | "destructive" | "muted";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variantClass: Record<BadgeVariant, string> = {
  success: "bg-[var(--color-success-soft)] text-[var(--color-success)]",
  warn: "bg-[var(--color-warning-soft)] text-[var(--color-warning)]",
  destructive: "bg-[var(--color-destructive-soft)] text-[var(--color-destructive)]",
  muted: "bg-[var(--color-muted-tint)] text-[var(--color-muted-foreground)]",
};

export function Badge({
  variant = "muted",
  className,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium",
        variantClass[variant],
        className,
      )}
      {...props}
    />
  );
}
